import Splide from '@splidejs/splide';

const selectors = {
  carousel: '[data-announcement-carousel]',
  slider: '[data-announcement-slider]',
  prev: '[data-announcement-prev]',
  next: '[data-announcement-next]',
};

export default class MainAnnouncementBar {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.wrapperEl = this.el.querySelector(selectors.carousel);
    this.carouselEl = this.el.querySelector(selectors.slider);
    this.prevBtn = this.wrapperEl?.querySelector(selectors.prev);
    this.nextBtn = this.wrapperEl?.querySelector(selectors.next);
    this.splide = null;
    this.onPrevClick = () => this.splide?.go('<');
    this.onNextClick = () => this.splide?.go('>');

    this._init();
  }

  _init() {
    if (!this.carouselEl || !this.wrapperEl || this.data.slideCount <= 1) {
      return;
    }

    this.splide = new Splide(this.carouselEl, {
      perPage: 1,
      perMove: 1,
      gap: 0,
      type: 'loop',
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      arrows: false,
      pagination: false,
    });

    this.splide.mount();

    this.prevBtn?.addEventListener('click', this.onPrevClick);
    this.nextBtn?.addEventListener('click', this.onNextClick);
  }

  onSectionUnload() {
    this.prevBtn?.removeEventListener('click', this.onPrevClick);
    this.nextBtn?.removeEventListener('click', this.onNextClick);

    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
